<div class="content-blk">
  <div class="container dv-rderlst-strdmin">
    <h5 class="page-title">
      Orders
    </h5>
    <div class="white-background">
      <app-order-filter (export)="exportExcel()" (search)="onFilterSearchTrigger($event)"
        [orderFilter]="orderFilter"></app-order-filter>
      <div class="text-center">
        <button class="btn btn-danger" style="font-size: 12px; padding: 5px;" (click)="fn_clearFilter()">Clear
          Filter</button>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="front-wrap">
      <div class="front-store-content">
        <div class="search-results" infiniteScroll [infiniteScrollDistance]="6" [infiniteScrollThrottle]="100"
          [infiniteScrollDisabled]="scrollDisabled || isFullListDisplayed" (scrolled)="fn_GetOrderListing(false)">
          <div class="order-container">

            <div class="row">
              <div class="col-sm-12 itm-ord-ui">
                <app-no-order [orderList]="orderList" [filterApplied]="checkFilterApplied()" [loaded]="loaded">
                </app-no-order>

                <mat-card class="" [ngClass]="'spg-mat-card mat-card-cmn' + ' order-'+order.OrderStatus"
                  *ngFor="let order of orderList">
                  <mat-card-header class="order-title">
                    <mat-card-title>
                      <div class="row">
                        <div class="col-md-2">
                          <div><small *ngIf="order.IsSampleOrder" class="text-danger">*Sample Order</small></div>
                          <div><small *ngIf="order.IsReplacementOrder" class="text-danger">*Replacement Order</small>
                          </div>
                          <div class="ord-dt-no">
                            <div class="mat-btn mat-track">
                              <!--<strong class="l-s-0-6">{{order.OrderNo}}</strong>-->
                              <span title="View Order Status" class="mat-btn mat-track l-s-0-6" style="cursor: pointer;"
                                (click)="fn_RedirectToOrderDetail(order.OrderNo)">
                                <strong>{{order.OrderNo}}</strong>&nbsp;<i class="fa fa-external-link-square"
                                  aria-hidden="true"></i>
                              </span>

                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="ord-dt-no pd-l-10" *ngIf="order.TrackingNumber"
                            (click)="openTrackingNumberPopup(order.TrackingNumber, order.TrackingUrl)">
                            <div class="mat-btn mat-track bg-tracking">
                              <strong class="l-s-0-6">Tracking Details</strong>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div *ngIf="order.StatusOrderBrainTree.StatusInt === -1"
                            (mouseover)="changeOrderId(order.OrderId)">
                            <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                          </div>
                          <div class="text-info" *ngIf="order.IsShopifyOrder">
                            <span title="Payment is complted for the order." class="text-info l-s-0-6"
                              style="cursor: pointer;">
                              Payment: {{order.StatusOrderBrainTree.Status}}
                            </span>

                            <strong>

                            </strong>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="ord-dt od-dt-wp statusOrder">
                            <div class="mat-track text-info">
                              <strong class="l-s-0-6" *ngIf="order.IsOrderDeskOrder == true; else non_od_content">
                                <img src="assets/img/orderdesk_black.png" />
                                Order Desk# {{order.SourceOrderNumber}}
                              </strong>
                              <ng-template #non_od_content>
                                <strong class="l-s-0-6" *ngIf="order.IsShopifyOrder == true">
                                  Shopify Order# {{order.ShopifyOrderNo}}
                                </strong>
                                <strong class="l-s-0-6" *ngIf="order.IsShopifyOrder == false">
                                  MerchLoop Order# {{order.OrderNo}}
                                </strong>
                              </ng-template>
                            </div>
                            <!--<a style="cursor: pointer;color:white!important" class="mat-btn"
                               *ngIf="(order.OrderStatus === 'Ordered' || order.OrderStatus === 'Confirmed' || order.OrderStatus === 'Processing') && order.IsShopifyOrder == false"
                               (click)="fn_CancelOrder(order)">Cancel</a>-->

                            <ng-container *ngIf="!order.IsOrderDeskOrder">
                              <a style="cursor: pointer;color:white!important" class="mat-btn"
                                *ngIf="fn_ShowReportOrder(order)" (click)="fn_ReportOrder(order)">Report</a>
                              <a style="cursor: pointer; color: white !important" class="mat-btn"
                                *ngIf="order.ReportOrderStatus" [style.background]="getColor(order)">
                                {{fn_ReportOrderStatus(order)}}
                              </a>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content *ngFor="let item of order.OrderItems; let i = index;" class="rfnd-bd-wrp">
                    <div class="mat-sz-rt">
                      <div *ngIf="!item.IsWareHouseProduct" class="mat-sz-avt">
                        <img [src]="item.ImageName" />
                      </div>
                      <div *ngIf="item.IsWareHouseProduct" class="mat-sz-avt">
                        <img *ngIf="item.DesignId > 0" src="{{item.PngRelativeUrlWithProduct}}" />
                        <img *ngIf="item.IsWareHouseProduct"
                          src="{{imgWareHouseBaseURL + item.PngRelativeUrlWithProduct}}" />
                      </div>
                      <div class="mat-sz-ct">
                        <div class="row" style="margin-bottom:70px;">
                          <div class="col-sm-6">
                            <div class="mat-sz-inr">
                              <h4>
                                {{item.DesignName}}&nbsp;<span *ngIf="!item.IsWareHouseProduct" style="font-size:10px"
                                  class="text-info">({{item.CustomizeType}})</span> <sup class="text-danger"
                                  *ngIf="item.IsWareHouseProduct">&nbsp; **Warehouse Product</sup>
                              </h4>
                              <div class="st-row">
                                <div class="strng-col">Color <strong>{{item.ColorName}}</strong></div>
                                <div class="strng-col">Size <strong>{{item.SizeName }}</strong></div>
                                <div class="strng-col">
                                  Cost x Qty.
                                  <strong class="text-muted">{{item.UnitPrice | currency:'USD':'symbol':'1.2-2'}} x {{
                                    item.Quantity}}</strong>
                                  =
                                  <strong>{{item.UnitPrice * item.Quantity | currency:'USD':'symbol':'1.2-2'}}</strong>
                                </div>
                                <small *ngIf="item.FinishingPrice>0">Finishing Price/Piece <strong>{{item.FinishingPrice
                                    | currency:'USD':'symbol':'1.2-2'}} included. <br /></strong></small>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="mat-sz-inr">
                              <div *ngIf="item.IsCancelled" class="text-danger">
                                Cancelled
                              </div>
                              <div *ngIf="!item.IsCancelled">
                                {{item.ItemStatus}}
                              </div>
                              <div class="st-row">
                                <div class="strng-col">
                                  <mat-hint *ngIf="item.ItemStatus === 'Processing'" style="font-size: 11px;">
                                    Your item is being Processed
                                  </mat-hint>
                                  <mat-hint *ngIf="item.ItemStatus != 'Processing'" style="font-size: 11px;">
                                    Your item has been
                                    {{item.ItemStatus | lowercase}}
                                  </mat-hint>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-qt" *ngIf="i== 0">
                          <strong style="margin-right:0px;">Shipping Address</strong>
                          <br />
                          <small *ngIf="order.AddressModel" class="sml-ordrlst-addrss">
                            <p> {{order.AddressModel.Name}}
                            </p>
                            <p> {{order.AddressModel.AddressLine}}
                            </p>
                            <p *ngIf="order.AddressModel.AddressLine2">
                                {{order.AddressModel.AddressLine2}}                              
                            </p>
                            <p> {{order.AddressModel.Country}} {{order.AddressModel.CountryCode}},
                              {{order.AddressModel.State}}
                              {{order.AddressModel.StateCode}} - {{order.AddressModel.ZipCode}}
                            </p>
                            <p>
                              <span class="text-info">Contact No.: </span> {{order.AddressModel.PhoneNumber | mask: '(000) 000-0000'}}
                            </p>
                            <p>
                              <span class="text-info">Email: </span> {{order.AddressModel.Email }}
                            </p>
                          </small>
                        </div>
                      </div>
                      <label *ngIf="order.OrderStatus === 'Cancelled' &&  order.IsRefunded"
                        class="label label-default rfnd-tag">
                        Refunded
                      </label>
                    </div>
                  </mat-card-content>
                  <mat-card-actions>
                    <div class="row">
                      <div class="col-sm-4">
                        Ordered On : {{getDate(order.OrderDate) | date:'fullDate'}}
                      </div>
                      <div class="col-sm-2  text-right">
                        <ng-container *ngIf="order.Discount">
                          Discount : <strong>{{ order.Discount| currency:'USD':'symbol':'1.2-4'}} </strong>
                        </ng-container>
                      </div>
                      <div class="col-sm-3  text-right">
                        Shipping : <strong>{{ order.ShippingCost| currency:'USD':'symbol':'1.2-4'}} </strong>
                      </div>
                      <div class="col-sm-3  text-right">
                        Order Total : <strong>{{order.TotalPrice | currency:'USD':'symbol':'1.2-4'}}</strong>
                      </div>
                    </div>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
          <app-lazy-loader></app-lazy-loader>
        </div>
      </div>
    </div>
  </div>
</div>